import { useCallback } from 'react';

export const useControlImageCommand = () => {
    const execute = useCallback(async ({ json, pageIndex, isDoublePageMode, interactiveObjectState, setInteractiveObjectState }) => {
        const baseIndex = pageIndex - pageIndex % 2;
        let foundItem = null;

        for (let item of interactiveObjectState.state) {
            if (item.pageIndex.includes(pageIndex)) {
                foundItem = item;
                break;
            }
        }

        //如果Display是否存在
        if (!foundItem) {
            //創建新的display
            foundItem = {
                pageIndex: isDoublePageMode ? [baseIndex, baseIndex + 1] : [pageIndex],
                image: json.controlObject.split(",").map(objId => ({ id: objId, src: json.src }))
            };
            interactiveObjectState.state.push(foundItem);
        } else {
            foundItem.image = json.controlObject.split(",")
                .filter((objId) => foundItem.image.map(image => image.id).includes(objId))
                .map(objId => ({ id: objId, src: json.src }))
        }

        setInteractiveObjectState({ ...interactiveObjectState, version: interactiveObjectState.version ? interactiveObjectState.version + 1 : 1 })
    }, []);

    return { execute };
};
